import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { IconSprite } from '@portal/shared/ui/icon/icon-sprite';

/**
 * Root component. Carries the icon sprite once for the whole application -- every `portal-icon`
 * references a symbol out of it, so icons cost no requests and cannot flicker in.
 */
@Component({
  selector: 'portal-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, IconSprite],
  template: `
    <portal-icon-sprite />
    <router-outlet />
  `
})
export class App {}